<template>
  <section id="default-page-template">
    <div class="coverPhoto" style="background-image: url(img/contact-bg.jpg)">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-8">
            <div class="header-title">
              <h2>
                Na kontaktoni për më shumë
                <span>informacion</span>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container align-items-center">
      <div class="row">
        <div class="col-12 white-content">
          <div class="row sm-title mb-30">
            <div class="col-12">
              <h3>Kontakt forma</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-8">
              <form class="col-12">
                <div class="row mb-4" :class="{ 'mb-md-0': formError.name }">
                  <div class="col-12 mb-2 col-md-6 form-group" :class="{'mb-0': formError.name }">
                    <div class="row mb-0 mb-md-0 pr-md-1">
                      <input
                          :class="{ 'border-danger': formError.name }"
                          class="w-100"
                          type="text"
                          placeholder="emri dhe mbiemri"
                          :value="name"
                          @input="getName"
                      >
                    </div>
                    <div class="row">
                      <p v-if="formError.name" class="text-danger mb-3">
                        <i class="fa fa-exclamation-circle"></i>
                        <small class="pl-2">Shkruani emrin dhe mbiemrin!</small>
                      </p>
                    </div>
                  </div>
                  <div class="col-12 px-0 col-md-6 form-group">
                    <div>
                      <input
                          :class="{ 'border-danger': formError.email }"
                          class="w-100"
                          type="email"
                          placeholder="email"
                          :value="email"
                          @input="getEmail"
                      >
                    </div>
                    <div>
                      <p v-if="formError.email" class="text-danger mb-1">
                        <i class="fa fa-exclamation-circle"></i>
                        <small class="pl-2">Shkruani një email valide!</small>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-12 px-0 mb-4 form-group">
                  <div class="row">
                    <textarea
                        :class="{ 'border-danger': formError.message }"
                        class="w-100"
                        rows="6"
                        placeholder="mesazhi"
                        :value="message"
                        @input="getMessage"
                    ></textarea>
                  </div>
                  <div class="row">
                    <p v-if="formError.message" class="text-danger mb-1">
                      <i class="fa fa-exclamation-circle"></i>
                      <small class="pl-2">Shkruani mesazhin jo më shumë se 2048 karaktere!</small>
                    </p>
                  </div>

                  <p class="row mb-0 text-danger mt-3" v-if="formError">Ju lutem plotësoni të gjitha fushat!</p>
                  <p class="row text-success mt-2"
                     v-if="messageSent"
                  >Ju faleminderit, do t'ju kontaktojmë së shpejti.</p>
                </div>
                <div class="row form-group">
                  <button class="w-100 col-md-4" type="submit" @click="sendMessage">dërgo</button>
                </div>
              </form>
            </div>
            <div class="col-12 col-md-4 mt-4 mt-md-0 address">
              <h4>Zyra qendrore</h4>
              <p>
                Rr. Jusuf Gërvalla, nr.64
                <br>10 000,
                Prishtinë, Kosovë
              </p>
              <a href="tel:+383 44 662 663">+383 44 662 663</a>
              <br>
              <a href="tel:0800 22 800">0800 22 800 - pa pagesë</a>
              <ul>
                <li>
                  <a href="https://www.facebook.com/marimanga.net" target="_blank">
                    <i class="fa fa-facebook-official" aria-hidden="true"></i>
                  </a>
                </li>

                <li>
                  <a href="https://www.instagram.com/marimangaks" target="_blank">
                    <i class="fab fa-instagram" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
export default {
  name: "ContactForm",
  methods: {
    getName(e) {
      this.$store.dispatch("contact/getName", e.target.value);
    },
    getEmail(e) {
      this.$store.dispatch("contact/getEmail", e.target.value);
    },
    getMessage(e) {
      this.$store.dispatch("contact/getMessage", e.target.value);
    },
    sendMessage(e) {
      e.preventDefault();
      this.$store.dispatch("contact/sendMessage");
    }
  },
  computed: {
    name() {
      return this.$store.getters["contact/name"];
    },
    email() {
      return this.$store.getters["contact/email"];
    },
    message() {
      return this.$store.getters["contact/message"];
    },
    formError() {
      return this.$store.getters["contact/error"];
    },
    messageSent() {
      return this.$store.getters["contact/sent"];
    }
  }
};
</script>
